<template>
  <div>
    <v-app>
      <v-layout wrap>
        <v-flex xs12>
          <v-main>
            <!-- Header -->
            <Header/>
            
            <!-- Global Loading Spinner (OUTSIDE router-view) -->
            <LoadingSpinner :isLoading="$store.getters.isLoading" />
            
            <!-- Router View -->
            <router-view />
            
            <!-- Footer -->
            <Footer/>
          </v-main>
        </v-flex>
      </v-layout>
    </v-app>
  </div>
</template>

<script>
import "./assets/style/fonts.css";
import "./assets/style/style.css";
import Header from "./components/HeaderPage.vue";
import Footer from "./components/FooterPage.vue";
import LoadingSpinner from '@/components/LoadingSpinner.vue';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    LoadingSpinner
  },
  data: () => ({
    //
  }),
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
}

/* Smooth Scrolling */
html {
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
}

html,
body {
  scroll-behavior: smooth;
}

/* Smooth scroll for all scrollable elements */
* {
  scroll-behavior: smooth;
}

/* Optimize scrolling performance */
html,
body {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
